export const CSP_LABEL_KEY = 'cspPartnerLabel'

export const STORE_KEYS = {
  csps: 'csps',
  cspCodes: 'cspCodes',
  cspCategoryCodes: 'cspCategoryCodes',
  cspCodesByCategory: 'cspCodesByCategory',
  cspLabels: 'cspLabels',
  cspCategoriesLabels: 'cspCategoriesLabels',
}
